export default __webpack_public_path__ + "static/media/s1.fc979575.webp";